import $ from 'jquery';

function putWishDataInDataLayer(device) {
  const wishData = {
    event: 'submit_wish',
    maximum_value: parseInt($('.js-explanation-n-lead-form__form-desktop .js-explanation-n-lead-form__maximum-value-input').val(), 10),
    courses: [$(`.js-explanation-n-lead-form__form-${device} .js-canonical-selector`).val()],
    email: $(`.js-explanation-n-lead-form__form-${device} .js-explanation-n-lead-form__email-input`).val(),
    notify_by_email: true,
    notify_by_whatsapp: false,
    origin: $(`.js-explanation-n-lead-form__form-${device} .js-explanation-n-lead-form__wish-origin`).val(),
  };

  dataLayer.push(wishData);
}

['mobile', 'desktop'].forEach((deviceName) => {
  $(`.js-explanation-n-lead-form__form-${deviceName} .js-explanation-n-lead-form__submit`).on('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.currentTarget.disabled = true;

    if (e.currentTarget.form.checkValidity()) {
      putWishDataInDataLayer(deviceName);

      setTimeout(() => {
        $(`.js-explanation-n-lead-form__form-${deviceName}`).trigger('submit');
      }, 1000);
    } else {
      e.currentTarget.form.reportValidity();
      e.currentTarget.disabled = false;
    }
  });
});
